<template>
	<div class="tusd-wrap wrap-bg">
		<div class="page-title">
			<i class="back-btn" @click="goBack"></i>
			添加账户
		</div>
		<div class="separator"></div>
		<div class="account-wrap">
			<div class="wrap-item">
				<span class="item-label">银行类型：</span>
				<cube-select v-model="account.bankID" :options="bankOptions"  @change="selectBank"></cube-select>
			</div>
			<div class="wrap-item">
				<span class="item-label">收<i class="space three"></i>款<i class="space three"></i>人：</span>
				<input type="text" v-model="account.bankUser" placeholder="请输入收款人姓名" />
			</div>
			<div class="wrap-item">
				<span class="item-label">
					收款账号：
				</span>
				<input type="text" v-model="account.bankAccount" placeholder="请输入收款人账号" />
			</div>
			<div class="wrap-item">
				<span class="item-label">
					支行地址：
				</span>
				<input type="text" v-model="account.bankAddress" placeholder="请输入支行地址" />
			</div>
		   <div class="wrap-item">
				<span class="item-label">单日限单量：</span>
				<span class="unit">个</span>
				<input type="text" v-model="account.dayLimitOrderCount" placeholder="请输入单日限单数量" />
			</div>
			<div class="wrap-item">
				<span class="item-label">单日总限额：</span>
				<span class="unit">元</span>
				<input type="text" v-model="account.dayLimit" placeholder="请输入单日总限额" />
			</div>
			<div class="wrap-item">
				<span class="item-label">单笔最低：</span>
				<span class="unit">元</span>
				<input type="text" v-model="account.perLimitMin" placeholder="请输入单笔最低限额" />
			</div>
			<div class="wrap-item">
				<span class="item-label">单笔最高：</span>
				<span class="unit">元</span>
				<input type="text" v-model="account.perLimit" placeholder="请输入单笔最高限额" />
			</div>
			<div class="wrap-item">
				<span class="item-label">分组管理：</span>
				<cube-select v-model="account.groupId" :options="bankGroupOptions"  @change="selectBankGroup"></cube-select>
			</div>
			<div class="wrap-item">
				<span class="item-label">订单客户：</span>
				<div class="radio-wrap">
					<cube-radio-group
					@input="changePaymentCustomerLimit"
					v-model="optionCheckedValue.paymentCustomerLimitValue"
					:options="paymentCustomerLimitOptions"
					:horizontal="true"
					/>
				</div>
			</div>
			<div class="wrap-item">
				<span class="item-label">同时进账：</span>
				<div class="radio-wrap">
					<cube-radio-group
					@input="changeIsNeedLockedOrder"
					v-model="optionCheckedValue.isNeedLockedOrderValue"
					:options="isNeedLockedOrderOptions"
					:horizontal="true"
					/>
				</div>
			</div>
			<div class="tusd-btn first-btn" @click="addAccount">确认添加</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'addAccount',
	data() {
		return {
			account: {
				bankID:"",
				bankUser: '',
				bankName: '',
				bankAccount: '',
				bankAddress: '',
				perLimit:50000,
				dayLimit:500000,
				perLimitMin:1000,
				dayLimitOrderCount:1,
				groupId:"",
				paymentCustomerLimit:0,
				isNeedLockedOrder:0
			},
			bankOptions: [],
			bankGroupOptions: [],
			params: {},
			optionCheckedValue: {
				paymentCustomerLimitValue:"全部",
				isNeedLockedOrderValue:"允许"
			},
			statusOptions: ["是", "否"],		
			status: [
				{
				label: "是",
				value: 1
				},
				{
				label: "否",
				value: 0
				}
			],
			paymentCustomerLimitOptions: ["全部","正常","新疆"],
			paymentCustomerLimitProp: [
				{
				label: "全部",
				value: 0
				},
				{
				label: "正常",
				value: 1
				}
				,
				{
				label: "新疆",
				value: 2
				}
			],
			isNeedLockedOrderOptions:["允许","禁止"],
			isNeedLockedOrderProp: [
				{
				label: "禁止",
				value: 1
				},
				{
				label: "允许",
				value: 0
				}
			],
		};
	},
	methods: {
		goBack() {
			this.$router.push({ name: this.params.back });
		},
		changePaymentCustomerLimit(v) {
		  this.account.paymentCustomerLimit = this.getProp(v, this.paymentCustomerLimitProp);
		},
		changeIsNeedLockedOrder(v) {
		  this.account.isNeedLockedOrder = this.getProp(v, this.isNeedLockedOrderProp);
		},
		getBankList() {
			let that=this;
			this.$api.getBanks().then((res)=>{
				res.data.map(v => {
					let temp={text:v.BankName,value:v.ID};
					that.bankOptions.push(temp)
				})
			});
		},
		getUserBankGroupList() {
			let that=this;
			this.$api.getUserBankGroups().then((res)=>{
				res.data.filter((item)=>item.PayType == 1).map(v => {
					let temp={text:v.Title,value:v.Id};
					that.bankGroupOptions.push(temp)
				})
			});
		},
		getProp(v, o, r) {
			let prop = '';
			o.map(i => {
				if (r) {
					if (i.value == v) {
						prop = i.label;
					}
				} else {
					if (i.label == v) {
						prop = i.value;
					}
				}
			});
			return prop;
		},
		selectBank(value,index,text){
			this.account.bankID=value;
			this.account.bankName=text;
		},
		selectBankGroup(value,index,text){
			this.account.groupId=value;
		},
		addAccount(){
			let that=this;
			if(that.account.bankID && !that.account.bankName){
				that.$message.popup("请选择银行类型",1000);
				return false
			}
			if(!that.account.bankUser){
				that.$message.popup("请输入收款人姓名",1000);
				return false
			}
			if(!that.account.bankAccount){
				that.$message.popup("请输入银行卡号",1000);
				return false
			}
			// if(!that.common.checkluhnBankNo(that.account.bankAccount)){
			// 	that.$message.popup("银行卡号格式不正确，请检查",1000);
			// 	return false
			// }
			if(!that.account.bankAddress){
				that.$message.popup("请输入支行地址",1000);
				return false
			}
			if(!that.account.groupId){
				that.$message.popup("请选择分组管理",1000);
				return false
			}
			if (!that.account.dayLimit  || that.account.dayLimit < 500) {
				that.$message.popup("请输入单日总限额,最低金额500", 1000);
				return false
			}
			if (!that.account.perLimitMin  || that.account.perLimitMin < 500) {
				that.$message.popup("请输入单笔最低限额,最低金额500", 1000);
				return false
			}
			if (!that.account.perLimit || that.account.perLimit < 500) {
				that.$message.popup("请输入单笔最高限额,最低金额500", 1000);
				return false
			}
     		 if (!that.account.dayLimitOrderCount || that.account.dayLimitOrderCount < 1) {
				that.$message.popup("请输入单日限单量,最少一单", 1000);
				return false
			}
		    if(parseInt(that.account.perLimit) < parseInt(that.account.perLimitMin)) {
				that.$message.popup("单笔最高不得低于单笔最低", 1000);
				return false
			}
			that.$api.addBank(that.account).then((res)=>{
				that.$message.popup("添加银行卡成功",1000);
				that.goBack();
			})
		}
	},
	created() {
		this.params = this.$store.state.routerStore.addAccount;
		if (!this.params.back) {
			this.params.back = 'accounts';
		}
		this.getBankList();
		this.getUserBankGroupList();
	}
};
</script>
